import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site-info';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: '快速导航',
      links: [
        { label: '首页', to: '/' },
        { label: '分类导航', to: '/categories' },
        { label: '关于我们', to: '/about' },
      ],
    },
    {
      title: '热门分类',
      links: [
        { label: '平台入口', to: '/categories?tab=platform-entry' },
        { label: '注册登录', to: '/categories?tab=register-login' },
        { label: '使用教程', to: '/categories?tab=tutorials' },
        { label: '功能解析', to: '/categories?tab=features' },
      ],
    },
    {
      title: '帮助支持',
      links: [
        { label: '常见问题', to: '/categories?tab=faq' },
        { label: '联系客服', to: '/about#contact' },
        { label: '用户协议', to: '#' },
        { label: '隐私政策', to: '#' },
      ],
    },
  ];

  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-background-50/20 flex items-center justify-center">
                <span className="text-background-50 font-bold text-sm font-heading">51</span>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">{siteInfo.name}</span>
            </Link>
            <p className="text-background-50/70 text-sm leading-relaxed">{siteInfo.description}</p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 rounded-full bg-background-50/15 flex items-center justify-center hover:bg-background-50/25 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-background-50/15 flex items-center justify-center hover:bg-background-50/25 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-background-50/15 flex items-center justify-center hover:bg-background-50/25 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-base font-semibold mb-4 text-background-50">{group.title}</h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-background-50/65 text-sm hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-50/15 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-50/50 text-sm">
            &copy; {currentYear} {siteInfo.name} 版权所有
          </p>
          <div className="flex items-center gap-4 text-background-50/50 text-sm">
            <span>{siteInfo.address}</span>
            <span className="hidden sm:inline">|</span>
            <span>客服热线：{siteInfo.phone}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}